import React, { useState } from "react";
import { Lightbox } from "../../Components/Lightbox/Lightbox";
import { ImageContentParams } from "./ImageContentParams.csharp";

export const ImageContent: React.FC<ImageContentParams> = ({
  url,
  imageUrl,
  altDescription,
  isLightbox,
}) => {
  const [isLightboxOpened, setIsLightboxOpened] = useState<boolean>(false);

  const imageElement: React.ReactElement<"img"> = (
    <img
      src={`${imageUrl}?rmode=crop`}
      alt={altDescription}
    />
  );

  return (
    <>
      <picture className="image-content__media">
        {!url && !isLightbox && imageElement}
        {!!url && <a href={url}>{imageElement}</a>}
        {!url && isLightbox && (
          <button
            onClick={() => setIsLightboxOpened(true)}
            className="image-content__lightboxButton"
          >
            {imageElement}
          </button>
        )}
      </picture>
      {!url && isLightbox && (
        <Lightbox
          isOpened={isLightboxOpened}
          onClose={() => setIsLightboxOpened(false)}
          children={imageElement}
        />
      )}
    </>
  );
};
